/**
 * Reclaim Our Presence — Activations Full Page
 *
 * The `/reclaim-presence/activations` route — a full-page view of the
 * 13 Daily Awareness activation cards, reached from the preliminary
 * landing page. Reuses the existing DailyAwarenessSection component
 * (single source of truth for the card list + rendering).
 */
import { useNavigate } from 'react-router-dom';
import DailyAwarenessSection from './DailyAwarenessSection';

export default function PresenceActivationsPage() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen text-[#F2EFE9]"
      style={{
        background:
          'radial-gradient(ellipse at top, #1A2622 0%, #0F1A16 55%, #060B09 100%)',
        fontFamily: '"Manrope", sans-serif',
      }}
      data-testid="presence-activations-page"
    >
      <header className="relative flex items-center justify-center px-6 pt-6 pb-2">
        <button
          onClick={() => navigate('/reclaim-presence')}
          className="absolute top-6 left-6 text-2xl leading-none opacity-60 hover:opacity-100"
          data-testid="presence-activations-back"
        >
          ←
        </button>
        <p
          className="uppercase tracking-[0.4em] text-[10px] opacity-70"
          style={{ color: '#7EE2C8' }}
        >
          Reclaim Our Presence
        </p>
      </header>

      <main className="max-w-lg mx-auto px-4 pt-4 pb-16">
        <DailyAwarenessSection />
      </main>
    </div>
  );
}
